export default angular.module('ApiUtils.dms.cropData', []);

